import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCephComponent } from './simple-icons-ceph.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCephComponent ],
    exports:      [ SimpleIconsCephComponent ],
    bootstrap:    []
})
export class SimpleIconsCephModule {}
